import { render, staticRenderFns } from "./QNotification.vue?vue&type=template&id=3c04e718&"
import script from "./QNotification.vue?vue&type=script&lang=js&"
export * from "./QNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports